import { ActivityEntityName, EntityQueueFieldSource, EntityViewDisplay, EntityViewSortDirection } from '@jms/model';
import { resolveColumnUiFields, toQueueFieldOptions } from '../../queue.field.options';
import { createEntityAdapter } from './entity.step.adapter';
import { QueueAdapterDeps, QueueStepAdapter } from './queue.step.adapter';

export const createEntityJobAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createEntityAdapter(deps, {
    entity: ActivityEntityName.Job,
    entityLabel: 'Job',
    resolveColumnOptions: map => {

      const jobMeta = map[ActivityEntityName.Job];
      return jobMeta ? toQueueFieldOptions(resolveColumnUiFields(jobMeta), 'entity', jobMeta.displayName ?? 'Job', true) : [];
    },
    defaultTable: () => ({
      display: EntityViewDisplay.Table,
      fixed: [],
      other: [
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.jobNumber' }, name: 'Job Number', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.customer' }, name: 'Customer', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.site' }, name: 'Site', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.status' }, name: 'Status', visible: true },
      ],
      sortBy: { source: EntityQueueFieldSource.Entity, path: 'entity.createdAt' },
      sortOrder: EntityViewSortDirection.Asc,
    }),
  });
